import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import useGlobalConfirmBox from 'features/GlobalConfirmBox/hooks/useGlobalConfirmBox'
import useOpenConferenceCall from 'features/ConferenceCall/hooks/useConferenceCall'
import { yayApi } from 'store/api/baseApi'
import { useNavigate } from 'features/i18n/router'
import { ROUTE_PATH } from 'lib/paths'
import { useGetGroupMutateMutation } from 'store/api/yay/group'

export const useCallItem = ({ call, attemptJoinGroup }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { showConfirmBox } = useGlobalConfirmBox()
  const { conference_call, group, user } = call
  const { openConferenceCall } = useOpenConferenceCall()
  const navigate = useNavigate()

  const [getGroupMutate] = useGetGroupMutateMutation()

  const onOpenConferenceCall = useCallback(() => {
    openConferenceCall({
      conferenceCallId: conference_call.id,
      inviteId: null,
      targetId: null,
    })
  }, [conference_call])

  const onCallClick = () => {
    if (group?.id) {
      if (group.is_joined) {
        showConfirmBox({
          title: t('call.group.open_conference.title'),
          content:
            conference_call.call_type === 'voice'
              ? t('call.group.joined.open_voice_conference.content', {
                  nickname: user.nickname,
                })
              : t('call.group.joined.open_video_conference.content', {
                  nickname: user.nickname,
                }),
          confirmBoxProps: {
            confirmButtonText: t('common.join'),
            onOk: onOpenConferenceCall,
          },
        })
      } else {
        showConfirmBox({
          title: t('call.group.open_conference.title'),
          content: t('call.group.not_joined.open_conference.content'),
          confirmBoxProps: {
            confirmButtonText: t(
              'call.group.not_joined.open_conference.join_group_and_call'
            ),
            confirmButtonStyle: 'green',
            onOk: async () => {
              const groupRes = await getGroupMutate({
                groupId: group?.id,
              })

              const attemptJoinGroupCallback = () => {
                dispatch(
                  yayApi.util.invalidateTags([
                    'Calls/All' as any,
                    'Calls/Following' as any,
                  ])
                )

                onOpenConferenceCall()
              }

              // Call's `group` does not contain `guidelines`.
              const attemptJoinGroupRes = await attemptJoinGroup?.(
                groupRes?.['data']?.group,
                attemptJoinGroupCallback
              )

              if (attemptJoinGroupRes?.['data']?.status == 'success') {
                attemptJoinGroupCallback()
              }
            },
            fluidButtons: true,
            extraButtons: [
              {
                content: t('common.see_group'),
                onClick: () => navigate(ROUTE_PATH.GROUP(group.id)),
              },
            ],
          },
        })
      }
    } else {
      onOpenConferenceCall()
    }
  }

  return {
    onCallClick,
  }
}
